import { render } from "./Weightroom1.vue?vue&type=template&id=1616bc33&scoped=true"
import script from "./Weightroom1.vue?vue&type=script&lang=js"
export * from "./Weightroom1.vue?vue&type=script&lang=js"

import "./Weightroom1.vue?vue&type=style&index=0&id=1616bc33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1616bc33"]])

export default __exports__